import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import {
  CompaniesService,
  Department,
  DepartmentColors,
  DepartmentColorService,
  DepartmentsService,
} from "@/api";
import _ from "lodash";

export type CompanyState = {
  departments: Department[] | null;
  departmentsColor: DepartmentColors | null;
};

const state: CompanyState = {
  departments: null,
  departmentsColor: null,
};

const getters: GetterTree<CompanyState, RootState> = {
  departments(state) {
    return state.departments;
  },
  departmentsColor: state => state.departmentsColor,
};

const mutations: MutationTree<CompanyState> = {
  SET_DEPARTMENTS: (state, departments: Department[]) => {
    state.departments = _.sortBy(departments || [], ["name"]);
  },
  SET_DEPARTMENTS_COLOR: (state, departmentsColor: DepartmentColors) => {
    state.departmentsColor = departmentsColor;
  },
};

const actions: ActionTree<CompanyState, RootState> = {
  loadDepartments: async ({ commit, rootState, getters }, force = false) => {
    const companyId =
      rootState.appContext.company?.id ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (rootState as any).superAdmin?.selectedCompany?.id;
    let hasDepartment = getters["departments"];
    if (force == true) hasDepartment = false;
    if (companyId && !hasDepartment) {
      try {
        const departmentList = await DepartmentsService.listDepartments({
          companyId,
        });
        commit("SET_DEPARTMENTS", departmentList.departments);
        commit("departmentAdmin/SET_DEPARTMENTS", departmentList.departments, {
          root: true,
        });
      } catch (e) {
        commit("alert/SET_SHOW_ERROR", e, { root: true });
      }
    }
  },
  fetchDepartmentsColor: async ({ commit, rootState }) => {
    const companyId =
      rootState.appContext.company?.id ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (rootState as any).superAdmin?.selectedCompany?.id;
    if (companyId) {
      try {
        const departmentColors = await DepartmentColorService.getCompanyDepartmentColor(
          {
            companyId,
          },
        );
        commit("SET_DEPARTMENTS_COLOR", departmentColors);
      } catch (e) {
        commit("alert/SET_SHOW_ERROR", e, { root: true });
      }
    }
  },
  setCompanyExpiry: async (
    { commit, rootState },
    payload: { companyId?: number; expiresAt?: string },
  ) => {
    const companyId = payload.companyId || rootState.appContext.company?.id;
    if (!companyId) {
      commit("alert/SET_SHOW_ERROR", "Company ID is required", { root: true });
      return;
    }
    try {
      const res = await CompaniesService.setCompanyExpiry({
        companyId,
        expiresAt: payload.expiresAt,
      });
      commit(
        "alert/SET_SHOW_SUCCESS",
        "Company expiration updated successfully",
        { root: true },
      );
      return res;
    } catch (e) {
      commit("alert/SET_SHOW_ERROR", e?.message || e, { root: true });
      throw e;
    }
  },
  setExpiration: async (
    { dispatch },
    payload: { companyId?: number; expiresAt?: string },
  ) => {
    return dispatch("setCompanyExpiry", payload);
  },
};

export const company: Module<CompanyState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
